var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0726 4.37512C7.85534 4.35156 4.39902 7.71965 4.37551 11.9274L4.37549 11.9302C4.32842 16.1427 7.7175 19.601 11.9278 19.6245L11.9306 19.6245C16.1431 19.6716 19.6013 16.2825 19.6249 12.0722L19.6249 12.0695C19.672 7.85689 16.2829 4.39864 12.0726 4.37512ZM3.37553 11.9204C3.40293 7.1515 7.31871 3.34855 12.0782 3.37514C16.8447 3.40177 20.6773 7.31515 20.6248 12.0792C20.5975 16.8451 16.6844 20.6769 11.9208 20.6245C7.1549 20.5971 3.32306 16.684 3.37553 11.9204Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.1729C11 16.7251 11.4477 17.1729 12 17.1729C12.5523 17.1729 13 16.7251 13 16.1729C13 15.6206 12.5523 15.1729 12 15.1729C11.4477 15.1729 11 15.6206 11 16.1729Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 6.12695C12.3864 6.12695 12.6998 6.44035 12.6998 6.82695V12.827C12.6998 13.2136 12.3864 13.527 11.9998 13.527C11.6132 13.527 11.2998 13.2136 11.2998 12.827V6.82695C11.2998 6.44035 11.6132 6.12695 11.9998 6.12695Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircle);
export default __webpack_public_path__ + "static/media/exclamation-circle.974568e8a5ef4771d61d2d48aa6a5136.svg";
export { ForwardRef as ReactComponent };